export class RouteWaypointModel {
    constructor(item = {}) {
        this.asset = null;
        this.waypoint = null;
        this.id = item.id || "";
        this.idx = item.idx || "";
        this.waypoint_id = item.waypoint_id || "";
        this.waypoint_name = item.waypoint_name || "";
        this.waypoint_type = item.waypoint_type || "";
        this.waypoint_icon = item.waypoint_icon || "";
        this.waypoint_time = item.waypoint_time || 0;
        this.is_asset = item.is_asset || false;
        this.asset_id = item.asset_id || "";
        this.uid = item.uid || "";
        this.full_address = item.full_address || "";
        this.waste_type = item.waste_type || "";
        this.download_type = item.download_type || "";
        this.has_route = item.has_route || false;
        this.has_device = item.has_device || false;
        this.has_alerts = item.has_alerts || false;
        this.lat = item.lat || "";
        this.lng = item.lng || "";
        this.uuids = item.uuids || [];
        this.order = item.order || 0;
        this.filling = item.filling || 0;
        this.island_filling = item.island_filling || 0;
        this.mooch = item.mooch || false;
        this.status = item.status || null;
        this.is_island = item.is_island || Boolean(item.island_id);
        this.island_id = item.island_id || "";
        this.asset_ids = item.asset_ids || [];
        this.uuid_info = item.uuid_info || [];
    }
    createWaypoint = function () {
        this.waypoint = {
            id: this.waypoint_id,
            name: this.waypoint_name,
            full_address: this.full_address,
            icon: this.waypoint_icon,
            type: this.waypoint_type,
            lat: this.lat,
            lng: this.lng,
        };
    };
    createAsset = function () {
        if (this.is_island) {
            this.asset = {
                id: this.island_id,
                is_island: true,
                island_id: this.island_id,
                asset_ids: this.asset_ids,
                uid: this.uid,
                full_address: this.full_address,
                lat: this.lat,
                lng: this.lng,
                order: this.order,
                uuid_info: this.uuid_info,
                island_filling: this.island_filling,
            };
        } else {
            this.asset = {
                id: this.asset_id,
                uid: this.uid,
                full_address: this.full_address,
                waste_type: this.waste_type,
                download_type: this.download_type,
                has_route: this.has_route,
                has_device: this.has_device,
                lat: this.lat,
                lng: this.lng,
                uuids: this.uuids,
                filling: this.filling,
            };
        }
    };
    createMooch = function () {
        this.asset = {
            id: this.id,
            uid: this.uid,
            full_address: this.full_address,
            waste_type: "fl",
            download_type: "ot",
            has_route: true,
            has_device: false,
            lat: this.lat,
            lng: this.lng,
            uuids: this.uuids,
            filling: this.island_filling,
        };
        this.waste_type = "fl";
    };

    setWaypoint = (item) => {
        this.waypoint = item;
        this.waypoint_id = item.id;
        this.waypoint_name = item.name;
        this.full_address = item.full_address;
        this.waypoint_type = item.type;
        this.waypoint_icon = item.icon;
        this.waypoint_time = item.time;
        this.lat = item.lat;
        this.lng = item.lng;
        this.is_asset = false;
        this.order = item.order;
    };
    setAsset = (item) => {
        this.asset = item;
        this.asset_id = item.id;
        this.is_asset = true;
        this.uid = item.uid;
        this.full_address = item.full_address;
        this.waste_type = item.waste_type;
        this.download_type = item.download_type;
        this.has_route = item.has_route;
        this.has_device = item.has_device;
        this.lat = item.lat;
        this.lng = item.lng;
        this.uuids = item.uuids;
        this.order = item.order;
    };
    setIsland = (item) => {
        this.asset = item;
        this.is_island = true;
        this.island_id = item.id;
        this.asset_ids = item.asset_ids || [];
        this.is_asset = true;
        this.asset_id = "";
        this.uid = item.name || item.uid;
        this.full_address = item.full_address || "";
        this.lat = item.lat;
        this.lng = item.lng;
        this.order = item.order;
        this.uuid_info = item.uuid_info || [];
        this.filling = item.filling || 0;
        this.island_filling = item.island_filling || 0;
    };
}
